import * as React from 'react';

const PrideLarge = () => (
  <svg
    width="186"
    height="26"
    viewBox="0 0 186 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M160.389 11.6644C168.055 11.6644 174.163 17.6695 174.163 24.9483C174.163 25.0598 174.161 25.1742 174.157 25.2887H176.104L176.108 24.9483C176.108 16.669 169.289 9.93315 160.795 9.72483L160.389 9.71948C159.925 9.71949 159.466 9.73894 159.013 9.77704V11.7296C159.465 11.6865 159.924 11.6644 160.389 11.6644Z"
      fill="url(#paint0_linear_3366_28479)"
    />
    <path
      d="M160.389 9.72118C169.094 9.72118 176.045 16.5423 176.045 24.8278C176.045 24.982 176.043 25.1356 176.038 25.2887H177.984L177.985 25.2682L177.99 24.8278C177.99 15.5577 170.354 8.01518 160.844 7.78159L160.389 7.77625C159.926 7.77625 159.467 7.79358 159.013 7.82761V9.77851C159.466 9.74056 159.925 9.72118 160.389 9.72118Z"
      fill="url(#paint1_linear_3366_28479)"
    />
    <path
      d="M160.39 7.77783C170.133 7.77792 177.926 15.4152 177.926 24.7074C177.926 24.9007 177.923 25.0933 177.916 25.2851H179.862L179.865 25.195L179.872 24.7074C179.872 14.4462 171.419 6.09754 160.892 5.83913L160.39 5.83289C159.921 5.83289 159.475 5.83779 159.015 5.86932V7.8192C159.475 7.78442 159.92 7.77783 160.39 7.77783Z"
      fill="url(#paint2_linear_3366_28479)"
    />
    <path
      d="M160.389 5.83423C171.172 5.83423 179.808 14.2881 179.808 24.5875C179.808 24.8199 179.804 25.0513 179.795 25.2817H181.741C181.743 25.2283 181.744 25.1749 181.746 25.1214L181.753 24.5875C181.753 13.3349 172.485 4.17988 160.941 3.89641L160.389 3.88928C159.924 3.88928 159.463 3.90366 159.006 3.93197L159.011 5.8841C159.468 5.85316 159.924 5.83423 160.389 5.83423Z"
      fill="url(#paint3_linear_3366_28479)"
    />
    <path
      d="M160.389 3.89087C172.212 3.89089 181.69 13.1609 181.69 24.467C181.69 24.7403 181.684 25.0125 181.674 25.2834H183.62C183.622 25.2051 183.625 25.1267 183.627 25.0481L183.635 24.467C183.635 12.2233 173.55 2.26134 160.989 1.95305L160.389 1.94592C159.921 1.94592 159.461 1.96038 159 1.98678L159.008 3.93086C159.468 3.90223 159.921 3.89087 160.389 3.89087Z"
      fill="url(#paint4_linear_3366_28479)"
    />
    <path
      d="M160.389 1.94494C173.251 1.94506 183.571 12.1544 183.571 24.4672C183.571 24.7401 183.566 25.012 183.556 25.2826H185.502C185.504 25.2203 185.506 25.158 185.508 25.0956L185.517 24.4672C185.517 11.2325 174.615 0.341137 161.038 0.00802223L160.389 0C159.925 0 159.459 0.004325 159.001 0.0284122V1.97619C159.459 1.95023 159.925 1.94494 160.389 1.94494Z"
      fill="url(#paint5_linear_3366_28479)"
    />
    <g clipPath="url(#clip0_3366_28479)">
      <path
        d="M16.4839 1.28845C20.5788 1.28858 23.2405 3.01917 24.3667 4.65369L19.7593 7.92322C18.5307 6.67328 17.1996 6.19275 15.8687 6.19275C13.9238 6.19293 13.105 7.24999 13.105 8.40369C13.105 9.26904 13.6164 9.94264 14.6401 10.808L16.2788 12.2504C17.9168 13.5965 19.4526 15.039 19.4526 17.4427C19.4524 22.154 15.7667 25.7112 9.41943 25.7113C5.11947 25.7113 2.04761 23.9809 0.307129 21.6732L4.91455 18.4037C6.14311 19.846 7.8834 20.7113 9.82861 20.7113C12.2855 20.7113 13.2073 19.4617 13.2075 18.308C13.2075 17.4426 12.695 16.8652 11.5688 15.9037L9.93115 14.4613C8.19069 13.019 6.85986 11.4804 6.85986 9.26892C6.86003 4.74983 10.9554 1.28845 16.4839 1.28845ZM77.7075 1.28845C81.8024 1.28853 84.4641 3.01917 85.5903 4.65369L80.9839 7.92322C79.7554 6.67331 78.4241 6.19282 77.0933 6.19275C75.1481 6.19275 74.3287 7.24989 74.3286 8.40369C74.3286 9.26907 74.8409 9.9426 75.8647 10.808L77.5024 12.2504C79.1405 13.5965 80.6763 15.039 80.6763 17.4427C80.676 22.154 76.9904 25.7113 70.6431 25.7113C66.3431 25.7113 63.1689 23.9809 61.5308 21.6732L66.1382 18.4037C67.3667 19.8459 69.1071 20.7112 71.0522 20.7113C73.5092 20.7113 74.431 19.4617 74.4312 18.308C74.4312 17.4426 73.9187 16.8652 72.7925 15.9037L71.1548 14.4613C69.4144 13.019 68.0835 11.4804 68.0835 9.26892C68.0837 4.74983 72.1791 1.28845 77.7075 1.28845ZM42.7954 25.2308H37.3687V20.3265H28.9741L26.1069 25.2308H19.5552L34.2974 1.76892H42.7954V25.2308ZM65.3188 6.67322H59.3813L53.8521 25.1342H47.7095L53.2378 6.67322H46.8901L48.4263 1.67322H66.9575L65.3188 6.67322ZM31.9429 15.3265H37.3687V6.28845L31.9429 15.3265Z"
        fill="white"
      />
    </g>
    <path
      d="M172.57 7.22449C172.57 10.1837 170.632 13.0409 166.686 13.9253C168.046 14.7757 168.931 16.0682 168.931 18.007C168.931 21.5445 166.346 25.2861 161.005 25.2861H148.726L155.563 1.47607H165.733C169.135 1.47607 172.57 3.07475 172.57 7.22449ZM164.305 6.57822H160.223L159.033 10.6599H163.42C165.359 10.6599 166.482 9.67352 166.482 8.27894C166.482 6.95238 165.427 6.57822 164.305 6.57822ZM159.815 20.1839C162.06 20.1839 162.91 18.8914 162.91 17.5989C162.91 16.3063 162.094 15.626 160.393 15.626H157.638L156.312 20.1839H159.815Z"
      fill="#FA5333"
    />
    <path
      d="M137.378 25.7623C130.371 25.7623 127.922 21.6125 129.52 16.0342L133.704 1.47607H139.827L135.507 16.6124C134.826 19.0275 135.813 20.252 137.718 20.252C139.282 20.252 140.507 19.5717 141.221 17.0546L145.711 1.47607H151.834L147.174 17.8029C145.745 22.735 142.82 25.7623 137.378 25.7623Z"
      fill="#FA5333"
    />
    <path
      d="M109.529 25.2861L116.366 1.47607H122.489L117.183 19.9118H126.639L125.074 25.2861H109.529Z"
      fill="#FA5333"
    />
    <path
      d="M97.2791 25.7624C92.279 25.7624 90 23.1093 90 19.0956C90 11.5104 95.4763 1 105.204 1C110.068 1 112.415 3.6191 112.79 6.7144L106.667 8.75526C106.429 7.6668 105.783 6.57835 104.184 6.57835C100.068 6.57835 96.4287 13.4492 96.4287 17.8371C96.4287 19.1977 97.041 20.1841 98.4015 20.1841C100 20.1841 101.667 18.8575 103.061 16.8167L108.3 19.5718C106.973 21.6127 103.3 25.7624 97.2791 25.7624Z"
      fill="#FA5333"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3366_28479"
        x1="159.013"
        y1="17.7396"
        x2="167.297"
        y2="17.7396"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#502E91" stopOpacity="0" />
        <stop offset="1" stopColor="#502E91" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3366_28479"
        x1="159.013"
        y1="16.7087"
        x2="167.272"
        y2="16.7087"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#336FE2" stopOpacity="0" />
        <stop offset="1" stopColor="#336FE2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3366_28479"
        x1="159.015"
        y1="15.678"
        x2="168.164"
        y2="15.678"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#55A17B" stopOpacity="0" />
        <stop offset="1" stopColor="#55A17B" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3366_28479"
        x1="159.006"
        y1="14.6461"
        x2="167.272"
        y2="14.6461"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC100" stopOpacity="0" />
        <stop offset="1" stopColor="#FFC100" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3366_28479"
        x1="159"
        y1="13.6146"
        x2="167.323"
        y2="13.6146"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF621D" stopOpacity="0" />
        <stop offset="1" stopColor="#FF621D" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3366_28479"
        x1="159.001"
        y1="12.703"
        x2="167.297"
        y2="12.703"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C2102A" stopOpacity="0" />
        <stop offset="1" stopColor="#C2102A" />
      </linearGradient>
      <clipPath id="clip0_3366_28479">
        <rect width="86" height="25" fill="white" transform="translate(0 1)" />
      </clipPath>
    </defs>
  </svg>
);

export default PrideLarge;
